import { render, staticRenderFns } from "./Matchinglist.vue?vue&type=template&id=345fee37"
import script from "./Matchinglist.vue?vue&type=script&lang=js"
export * from "./Matchinglist.vue?vue&type=script&lang=js"
import style0 from "./Matchinglist.vue?vue&type=style&index=0&id=345fee37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports